import { TypographyProps } from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';
import { ResponsiveTypography } from '../ResponsiveTypography';

interface OwnProps extends TypographyProps {}

export interface PageHeaderTextProps extends OwnProps {}

const PageHeaderTextBase: FunctionComponent<PageHeaderTextProps> = props => (
  <ResponsiveTypography
    variantXs="title"
    variantMd="headline"
    align="center"
    {...props}
  />
);

export const PageHeaderText = pure(PageHeaderTextBase);

PageHeaderText.displayName = 'PageHeaderText';
